export default "__VITE_ASSET__rmuumKCp__"